import request from '@/request/request';
import { GlobalState } from '@/store';
import {
  Button,
  Descriptions,
  Modal,
  Space,
  Spin,
  Table,
  TableColumnProps,
  Typography,
} from '@arco-design/web-react';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

const StatusList = [
  {
    label: '出库',
    value: 1,
  },
  {
    label: '入库',
    value: 2,
  },
  {
    label: '报废',
    value: 3,
  },
  {
    label: '退货',
    value: 4,
  },
];
const FrameDetailDialog = () => {
  const columns: TableColumnProps[] = [
    {
      title: '品牌',
      dataIndex: 'brand',
      width: 80,
      align: 'center',
    },
    {
      title: '型号',
      dataIndex: 'model',
      width: 80,
      align: 'center',
    },
    {
      title: '色号',
      dataIndex: 'color',
      width: 140,
      align: 'center',
    },
    {
      title: '材质',
      dataIndex: 'material',
      width: 80,
      align: 'center',
    },
    {
      title: '供应商',
      dataIndex: 'supplier',
      width: 150,
      align: 'center',
    },
    {
      title: '数量',
      dataIndex: 'total',
      width: 150,
      align: 'center',
    },
  ];
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState<any>(null);
  const [typeText, setTypeText] = useState('');
  const [statusText, setStatusText] = useState('');
  const [descriptionList, setDescriptionList] = useState<any[]>([]);
  const dispatch = useDispatch();

  const { frameDetailConfig } = useSelector((state: GlobalState) => state);

  const loadDetail = async () => {
    setLoading(true);
    try {
      const response = await request('/t-warehousing/getDetailById', {
        data: {
          id: frameDetailConfig.id,
        },
        method: 'GET',
      });
      if (response.code == 200) {
        setDetail(response.data);
      }
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (frameDetailConfig.visible && frameDetailConfig.id) {
      loadDetail();
    }
  }, [frameDetailConfig.id, frameDetailConfig.visible]);

  const getTitle = () => {
    return `隼目` + typeText + statusText + '单';
  };

  const buildDescriptionList = () => {
    const list = [
      {
        label: '店铺',
        value: detail?.storeName || '-',
        span: 1,
      },
      {
        label: `${statusText}时间`,
        value: detail?.createTime || '-',
        span: 1,
      },
      {
        label: '操作人',
        value: detail?.createBy || '-',
        span: 1,
      },
      {
        label: '合计数量',
        value: detail?.totalNum || '-',
        span: 1,
      },
      {
        label: '备注',
        value: detail?.remark || '',
        span: 3,
      },
    ];
    if ([3, 4].includes(detail?.status)) {
      list.push({
        label: '关联订单号',
        value: detail?.orderNum || '',
        span: 3,
      });
    }
    return list;
  };

  useEffect(() => {
    const type = detail?.type === 1 ? '镜架' : '镜片';
    const status =
      StatusList.find((item) => item.value === detail?.status)?.label || '';
    setTypeText(type);
    setStatusText(status);
    setDescriptionList(buildDescriptionList());
  }, [detail]);

  return (
    <Modal
      title={null}
      visible={frameDetailConfig.visible}
      footer={null}
      style={{
        width: '100vw',
        minHeight: '100vh',
        padding: '0 40px',
        boxSizing: 'border-box',
      }}
      unmountOnExit
      maskClosable={false}
      focusLock={false}
      closable={false}
      onCancel={() => {
        dispatch({
          type: 'update-frameDetailConfig',
          payload: {
            frameDetailConfig: {
              visible: false,
              id: null,
            },
          },
        });
      }}
    >
      <Spin loading={loading} style={{ width: '100%', height: '100%' }}>
        <Typography.Title
          heading={4}
          style={{
            textAlign: 'center',
          }}
        >
          {getTitle()}
        </Typography.Title>
        <Descriptions
          style={{ margin: '20px 0' }}
          colon="："
          column={4}
          tableLayout="fixed"
          layout="inline-horizontal"
          data={descriptionList}
        />
        <Table
          pagination={false}
          data={detail?.frameWarehousingDetails || []}
          columns={columns}
        />
      </Spin>

      <div
        // 全局变量中定义了no-print是在打印时隐藏
        className="no-print"
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          width: '100%',
          padding: '20px 40px',
          boxSizing: 'border-box',
          background: '#fff',
          borderTop: '1px solid #f0f0f0',
          // 居中
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Space style={{ gap: 20 }}>
          <Button
            type="primary"
            onClick={() => {
              dispatch({
                type: 'update-frameDetailConfig',
                payload: {
                  frameDetailConfig: {
                    visible: false,
                    id: null,
                  },
                },
              });
            }}
          >
            返回
          </Button>
          <Button
            disabled={loading || detail == null}
            type="primary"
            onClick={() => {
              window.print();
            }}
          >
            打印
          </Button>
        </Space>
      </div>
    </Modal>
  );
};
export default FrameDetailDialog;
